module.exports = __webpack_public_path__ + "388c2478c13b7069fe35a9c8ad50e2fe.png";